import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="intl-phone"
// Loads intl-tel-input dynamically for phone number formatting
export default class extends Controller {
  static values = {
    initialCountry: { type: String, default: "us" },
    preferredCountries: { type: Array, default: ["mx", "us", "ca", "gb"] }
  }

  static targets = ["input"]

  connect() {
    this.loadIntlTelInput()
  }

  async loadIntlTelInput() {
    if (typeof window.intlTelInput !== "undefined") {
      this.initializeInput()
      return
    }

    // Load CSS
    if (!document.querySelector('link[href*="intlTelInput"]')) {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.11/build/css/intlTelInput.css"
      document.head.appendChild(link)
    }

    // Load JS
    const script = document.createElement("script")
    script.src = "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.11/build/js/intlTelInput.min.js"
    script.onload = () => this.initializeInput()
    document.head.appendChild(script)
  }

  initializeInput() {
    if (this.inputTarget.dataset.itiInitialized) return

    this.iti = window.intlTelInput(this.inputTarget, {
      initialCountry: this.initialCountryValue,
      preferredCountries: this.preferredCountriesValue,
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.11/build/js/utils.js",
      separateDialCode: true,
      autoPlaceholder: "polite",
      formatOnDisplay: true,
      nationalMode: false
    })

    this.inputTarget.dataset.itiInitialized = "true"

    this.inputTarget.addEventListener("blur", () => this.validate())

    const form = this.inputTarget.closest("form")
    if (form) {
      form.addEventListener("submit", () => {
        if (this.inputTarget.value.trim() && this.iti.isValidNumber()) {
          this.inputTarget.value = this.iti.getNumber()
        }
      })
    }
  }

  validate() {
    const errorMsg = document.querySelector('[data-error-message="purchase_phone"]')
    if (this.inputTarget.value.trim() && !this.iti.isValidNumber()) {
      this.inputTarget.classList.add("border-red-500")
      if (errorMsg) errorMsg.classList.remove("hidden")
    } else {
      this.inputTarget.classList.remove("border-red-500")
      if (errorMsg) errorMsg.classList.add("hidden")
    }
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy()
    }
  }
}
